import styles from "../styles/settingsGeneralDetails.module.css";

// Reusable component for Yes/No radio buttons
export const SettingsBooleanRadioButtons = ({
    fieldName,
    formData,
    label,
    setFormData,
    hasFee,
    backendBoolField,
    backendFeeField,
  }: {
    fieldName: string;
    formData: any;
    label: string;
    setFormData: any;
    hasFee: boolean;
    backendBoolField: string;
    backendFeeField: string;
  }) => {
    const handleBoolChange = (e: any) => {
      const { name, value, type } = e.target;
  
      setFormData((prev: any) => ({
        ...prev,
        [backendBoolField]: value === "true",
      }));
    };
    const handleFeeChange = (e: any) => {
      const { name, value, type } = e.target;
      setFormData((prev: any) => ({
        ...prev,
        [backendFeeField]: value ? parseFloat(value) : 0,
      }));
    };
  
    return (
      <div style={{ marginTop: 20 }} className={styles.categorySelect}>
        <label>{label}</label>
        <div className={styles.strainOptions}>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <label>
              <input
                type="radio"
                name={fieldName}
                value="true"
                checked={formData[backendBoolField] === true}
                onChange={handleBoolChange}
              />
              Yes
            </label>
            <label>
              <input
                type="radio"
                name={fieldName}
                value="false"
                checked={formData[backendBoolField] === false}
                onChange={handleBoolChange}
              />
              No
            </label>
          </div>
          {formData[backendBoolField] === true && hasFee && (
            <div
              style={{
                marginTop: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 0,
              }}
            >
              <h6>Fee:</h6>
              <input
                type="number"
                name={`${fieldName}Fee`}
                value={formData[backendFeeField] || ""}
                onChange={handleFeeChange}
                placeholder="Enter fee"
                style={{ marginLeft: 0 }}
              />
            </div>
          )}
        </div>
      </div>
    );
  };